module.exports = __webpack_public_path__ + "static/assets/3rd-party-stream.09ff7ac.svg";